module.exports = __webpack_public_path__ + "media/stylesheets/images/spritesheet-51e5ff83113e17566a81b39df8c0ca92.png";